import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46778bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn dropdown-toggle text-white",
  type: "button",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "false",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("em", { class: "bi bi-bell h5" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "dropdown-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-6 fw-semibold text-white m-0" }, "Notifications")
], -1))
const _hoisted_4 = { class: "dropdown-header" }
const _hoisted_5 = {
  class: "overflow-auto",
  style: {"max-height":"290px"}
}
const _hoisted_6 = ["index"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar bg-white rounded-pill me-3" })
], -1))
const _hoisted_8 = { class: "flex-grow-1 align-self-stretch text-white" }
const _hoisted_9 = { class: "fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "dropdown-menu dropdown-menu-end border-0 shadow me-n5",
      style: _normalizeStyle({ width: _ctx.windowWidth > 576 ? '425px' : '300px' })
    }, [
      _hoisted_3,
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn rounded-pill", _ctx.filterByRead ? 'btn-outline-white' : 'btn-white']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateFilter', false)))
        }, " All ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn rounded-pill ms-2", _ctx.filterByRead ? 'btn-white' : 'btn-outline-white']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateFilter', true)))
        }, " Unread ", 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNotifications, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "dropdown-item notification d-flex align-items-start align-content-center py-3",
            key: item.notificationId,
            index: index
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-wrap m-0", { 'opacity-75': item.read === true }])
              }, [
                _createElementVNode("b", _hoisted_9, _toDisplayString(item.senderName), 1),
                _createTextVNode(" " + _toDisplayString(item.message), 1)
              ], 2),
              _createElementVNode("small", {
                class: _normalizeClass(item.read === true ? 'opacity-50' : 'opacity-75')
              }, _toDisplayString(item.createdAt), 3)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("em", {
                class: _normalizeClass(["bi text-white mt-3 ms-2 fs-3", item.read === true ? 'bi-eye-fill' : 'bi-eye'])
              }, null, 2)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ], 4)
  ]))
}